<template>
  <q-avatar
    class="date_element"
    rounded
    size="md"
    :color="color"
    :text-color="textColor"
  >
    <span class="day">
      {{ luxonDate.toFormat('d') }}
    </span>
    <span class="month">
      {{ luxonDate.toFormat('LLL') }}<template v-if="isNotThisYear">'{{ luxonDate.toFormat('yy') }}</template>
    </span>
  </q-avatar>
</template>

<script>
import { Dark } from 'quasar'

/**
 * Display a date within a circle
 */
export default {
  props: {
    // The date to display
    date: {
      type: String,
      required: true
    },
    // Color to show behind the date
    color: {
      type: String,
      default: Dark.isActive ? 'grey-8' : 'grey-1'
    },
    // Text color of date
    textColor: {
      type: String,
      default: Dark.isActive ? 'white' : 'grey-8'
    }
  },
  computed: {
    luxonDate () {
      return this.luxon.fromSQL(this.date)
    },
    isNotThisYear () {
      return !this.luxon.now().hasSame(this.luxonDate, 'year')
    }
  }
}
</script>
